/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Status_SentInputs */

const cs_chat_status_sent = /** @type {(inputs: Chat_Status_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odesláno`)
};

const en_chat_status_sent = /** @type {(inputs: Chat_Status_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent`)
};

/**
* | output |
* | --- |
* | "Sent" |
*
* @param {Chat_Status_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_status_sent = /** @type {((inputs?: Chat_Status_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Status_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_status_sent(inputs)
	return cs_chat_status_sent(inputs)
});